<div [ngClass]="containerClass">
    <label [ngClass]="labelClass" [for]="id">{{label}}</label>
    <div [ngClass]="inputClass">
        <div class="input-group input-group-merge" [ngClass]="{ 'is-invalid': invalid }">
            <input type="text" class="form-control avoid-auto-fill" [ngClass]="{ 'is-invalid': invalid }" [id]="id"
                [(ngModel)]='value' [placeholder]="placeholder" [disabled]="isDisabled" (blur)="onTouch()"
                [autocomplete]="'new-' + id" [maxlength]="maxlength" (focus)="onFocus()" [mask]="mask" readonly>
            <!-- readonly: avoid autofill in browser; remover when focus -->
        </div>
        <div *ngIf="invalid && displayErrorMessage" class="invalid-feedback">
            <p *ngIf="isRequired && errors?.required">{{label}} is required</p>
            <p *ngIf="isEmail && errors?.email">Email format is incorrect</p>
            <p *ngIf="errors?.requiredIpFormat">IP format is incorrect</p>
            <p *ngIf="errors?.requiredDhcpLeaseTimeFormat">Leasetime format is incorrect</p>
            <p *ngIf="errors?.url">Url format is incorrect</p>
            <p *ngIf="errors?.speedTestUrl">
                Url format is incorrect (ex. www.speedtest.myserver.com:8080)</p>
            <p *ngIf="errors?.emailLoop">
                Email loop format is incorrect (ex. john.doe&#64;gmail.com;jane.doe&#64;hotmail.com;)</p>
            <p *ngIf="errors?.maxlength">Maximum char is {{errors?.maxlength.requiredLength}} (you type:
                {{errors?.maxlength.actualLength}} )</p>
            <p *ngIf="errors?.minlength">Minimum char is {{errors?.minlength.requiredLength}} (you type:
                {{errors?.minlength.actualLength}} )</p>
            <p *ngIf="errors?.key">Pre-Shared Key's format is incorrect</p>
            <p *ngIf="errors?.custIdFormat">Only allow Letters and Numbers</p>
            <p *ngIf="errors?.requiredPingUrlFormat">Ping URL format is incorrect</p>
            <p *ngIf="errors?.requiredFixedHostMACFormat">MAC Address is invalid</p>
            <p *ngIf="errors?.reserveWords">{{errors?.reserveWords.title}} is reserved words.</p>
            <p *ngIf="errors?.serverId">Server ID or Host format is incorrect</p>
            <p *ngIf="errors?.creditCardNumber">Please enter a valid card number</p>
            <p *ngIf="errors?.expDate">Please enter a valid expiration date.</p>
            <p *ngIf="errors?.ipv6">Ipv6 format is incorrect</p>
        </div>
        <p class="mb-0" *ngIf="hint"><small class="text-muted">{{hint}}</small>
    </div>
</div>